import React from 'react';

import { useIsProductOfTheYear } from 'src/components/product-of-the-year/hooks';
import { ListCardProductOfTheYearAwardBadge } from 'src/components/product-of-the-year/badges';

import { ListCard } from './list-card';
import { ListCardContent } from './list-card-content';
import { ListCardMedia } from './list-card-media';
import { ListCardOfferFooter } from './list-card-offer-footer';
import { ListCardProductFooter } from './list-card-product-footer';

import type { BaseProps } from '../../types';

type Props = BaseProps;

export const ProductListCard: React.FC<Props> = props => {
  const {
    id,
    brand,
    diffPercentage,
    highlightedName,
    imageSize,
    imageSrc,
    name,
    price,
    properties,
    rank,
    rating,
    reviewsCount,
    selectable,
    selected,
    shouldLazyLoadImage,
    type = 'product',
    link,
    onClick,
    className,
    container,
    background,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
    priceInclShipping,
    store,
    priceCount,
  } = props;

  const cardProps = {
    id,
    link,
    className,
    container,
    background,
    selected,
    selectable,
    onClick,
    onDeselect,
    onSelect,
    buttonAriaLabel,
    ActionArea,
    FooterArea,
  };

  const contentProps = {
    name,
    highlightedName,
    rank,
    rating,
    reviewsCount,
    diffPercentage,
    price,
    priceInclShipping,
    properties,
    store,
  };
  const mediaProps = {
    name,
    selectable,
    selected,
    imageSrc,
    imageSize,
    shouldLazyLoadImage,
    brand,
  };
  const offerFooterProps = { store, link, onClick };
  const productFooterProps = { priceCount };

  // The card shouldn't be clickable for offers
  const isClickable = type === 'product';

  const productOfTheYearAward = useIsProductOfTheYear(
    type === 'product' ? id : undefined
  );

  return (
    <ListCard {...cardProps} isClickable={isClickable}>
      {productOfTheYearAward && (
        <ListCardProductOfTheYearAwardBadge
          badgeUrl={productOfTheYearAward.awardLogo}
          awardName={productOfTheYearAward.awardName}
          year={productOfTheYearAward.year}
        />
      )}
      <ListCardMedia {...mediaProps} />
      <ListCardContent {...contentProps} showFromPrice={type === 'product'} />
      <>
        {type === 'offer' && <ListCardOfferFooter {...offerFooterProps} />}
        {type === 'product' && (
          <ListCardProductFooter {...productFooterProps} />
        )}
      </>
    </ListCard>
  );
};
